import { render, staticRenderFns } from "./duplicate-widget.vue?vue&type=template&id=641f6adc&"
import script from "./duplicate-widget.vue?vue&type=script&lang=js&"
export * from "./duplicate-widget.vue?vue&type=script&lang=js&"
import style0 from "./duplicate-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports